import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderService } from '../../../services/header.service';
import { ControlService } from 'src/app/services/api/appliance/control-board.service';
import { Subject, filter, takeUntil } from 'rxjs';
import { Unit } from 'src/app/modules/feature/appliance/components/control-board/models/unit.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonApiResponse } from 'src/app/models/common-api-response.model';

const diableDropdounRoutes: string[] = [
  '/app/system-settings/water',
  '/app/system-settings/energy',
  '/app/asset/facility',
  '/app/asset/units',
  '/app/schedule-management/schedule-list',
  '/app/system-settings/general',
  '/app/appliance/control-board/add-schedule',
  '/app/appliance/control-board/edit-schedule',
  '/app/appliance/control-board/schedule',
  '/app/homepage',
  '/app/system-settings/homepage-behavior',
  '/app/system-settings/role-permission',
  '/app/system-settings/users',
  '/app/energy/consumption-report',
  '/app/system-settings/firmware',
  '/app/system-settings/mqttauth',
  '/app/system-settings/dropdown-settings',
  '/app/mosque-management/',
  '/app/alarms/',
  '/app/access-control/',
  
];
@Component({
  selector: 'app-building-dropdown',
  templateUrl: './building-dropdown.component.html',
  styleUrls: ['./building-dropdown.component.scss'],
  standalone: true,
  imports: [CommonModule,NgbDropdownModule]
})
export class BuildingDropdownComponent implements OnInit, OnDestroy {

  protected unsubscribe$ = new Subject<void>();
  buildingUnits: Unit[] = [];
  selectedUnit: Unit = null;
  facility:Unit[] = []
  isDropdownActive: boolean = true;

  constructor(
    private _headerService: HeaderService,
    private _controlService: ControlService,
    private _route: ActivatedRoute, private _router: Router
  ) {
    _controlService.api_get_units_dropdown().pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (response:CommonApiResponse<Unit[]>) => {
        var units = response?.data ?? [];
        this._headerService.setUnitDropdownUnits(units);
        units?.forEach((unit: Unit) => {
          if(unit.level === 0 ){
            this.facility.push(unit)
          }
          if (unit && unit.level != 0) {
            this.buildingUnits.push(unit)
          }
        });
        if (this.facility.length > 0) {
          this.selectBuilding(this.facility[0] as Unit);
        }else if(this.buildingUnits.length > 0){
          this.selectBuilding(this.buildingUnits[0] as Unit)
        }
      },
      error: err => { }
    });
  }

  ngOnInit(): void {
    if(this.isRouteDisabled(this._router.url)){
      this.isDropdownActive = false;
    }
    this.tooglDrodownOnChnage();
  }

  isRouteDisabled(url: string): boolean {
    return diableDropdounRoutes.some(route => url.startsWith(route));
  }

  tooglDrodownOnChnage(): void {
    this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (this.isRouteDisabled(event.url)) {
        this.isDropdownActive = false;
      } else {
        this.isDropdownActive = true;
      }
    });
  }
  selectBuilding(building: Unit) {
    if (this.selectedUnit && this.selectedUnit.id == building.id) {
      return;
    }
    this.selectedUnit = building
    this._headerService.triggerBuildingDropdownChange(building);
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
